/* eslint-disable import/prefer-default-export */

export const prepareExtractSelectedSentences = verbatim => selectedSentences =>
  selectedSentences.map(({ id, order }) => {
    const { sentences } = verbatim.find(({ id: vId }) => vId === id);
    return sentences.find(({ order: vOrder }) => vOrder === order);
  });
